import { useEffect } from "react";
import { getItemWebStorage, setItemWebStorage } from "../../features/webStorageSaver";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { showToastMessage } from "../../stateManagement/reducers";
import { useDispatch } from "react-redux";
import { setServiceAuthToken } from "../../features/auth";
import { useAuthenticateWeatherStationsServiceMutation } from "../../api/rtk/weatherStations/slices/weatherStationsApiSlice";

export function useAuthWeatherStationsService() {
    const dispatch = useDispatch();
    const currentConfig = getItemWebStorage("currentConfig");
    const { badgeKey: username, badgeCode: password } = currentConfig?.services?.weatherStations?.openDataOptions?.badge ?? {}
    const [authenticateWeatherStationsService] = useAuthenticateWeatherStationsServiceMutation();

    const token = useAppSelector(state => state.auth.tokens.services?.weatherStations);

    useEffect(() => {
        if (!token) {
            (async () => {
                try {
                    const data = await authenticateWeatherStationsService({ username, password }).unwrap();
                    const token = data?.token;
                    if (token) {
                        dispatch(setServiceAuthToken({ serviceId: "weatherStations", token }))
                        const localAuthTokens = getItemWebStorage("authTokens");
                        const newAuthTokens = { ...localAuthTokens, services: { ...localAuthTokens?.services, weatherStations: token } }
                        setItemWebStorage("authTokens", newAuthTokens)
                    }
                } catch (error: any) {
                    console.error('Authentication to WeatherStationsService failed.', error);
                    dispatch(showToastMessage({ messageType: "error", messageText: `Ошибка аутентификации в сервисе: ${error?.data?.message}`, windowType: "map" }))
                }
            })();
        }
    }, [token])

}